/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react'
import { jsx, Button as ButtonUI } from 'theme-ui'
import { useRouter } from 'next/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

import Text from '/components/Commons/Text'
import Box from '/components/Commons/Box'
import tracking from '/lib/tracking'
import getTrackingInfo from '/utils/getTrackingInfo'

import styles from './styles'

const ViewStats = ({ stats, responsive, statsTitle, surname }) => {
  const [viewStats, setviewStats] = useState(false)
  const router = useRouter()
  const locale = router?.query?.locale

  const { sendCSMEvent, sendAdobeEvent } = tracking()

  const changeViewStatus = () => {
    if (!viewStats) {
      const trackInfo = getTrackingInfo('potmViewStats', '', {
        buttonName: `${statsTitle} - ${surname}`,
      })

      sendCSMEvent(trackInfo, locale)
      sendAdobeEvent(trackInfo, locale)
    }
    setviewStats(!viewStats)
  }

  return (
    <>
      {!responsive ? (
        <Box sx={styles.stats}>
          <ButtonUI onClick={changeViewStatus} variant="buttons.viewStats">
            <Box sx={styles.containerStyles}>
              <Text>{statsTitle}</Text>
              <Box sx={styles.arrowLogo}>
                <FontAwesomeIcon
                  icon={viewStats ? faAngleUp : faAngleDown}
                  size="xs"
                  color="#B99A58"
                />
              </Box>
            </Box>
          </ButtonUI>
          <Box
            as="ul"
            sx={{
              ...styles.viewStatsContent,
              display: viewStats ? 'flex' : 'none',
            }}
          >
            {stats?.map((stat, index) => {
              return (
                <Box as="li" key={index} sx={styles.statLine}>
                  <Text textStyle="stats.title">{stat.title} &nbsp;</Text>
                  <Text textStyle="stats.value">{stat.value}</Text>
                </Box>
              )
            })}
          </Box>
        </Box>
      ) : (
        <Box boxStyle="statsMobile">
          {stats?.map((stat, index) => {
            return (
              <Box key={index} sx={styles.statMobile}>
                <Text textStyle="stats.title">{stat.title}</Text>
                <Text textStyle="stats.value">{stat.value}</Text>
              </Box>
            )
          })}
        </Box>
      )}
    </>
  )
}

export default ViewStats
